import { CancelablePromise, OpenAPI, Response } from "@/api";
import { request as __request } from "@/api/core/request";
import { ToDeleteRequest } from "@/utils/slice";
import { ReplyAddRequest } from "@/api/models/reply/ReplyAddRequest";
import { ReplyListRequest } from "@/api/models/reply/ReplyListRequest";
import { ReplyListResponse } from "@/api/models/reply/ReplyListResponse";

export class ReplyService {
  public static Add(body: ReplyAddRequest): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/admin/reply",
      body: body,
    });
  }

  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/reply",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/reply/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static ListAll(
    body: ReplyListRequest
  ): CancelablePromise<ReplyListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/reply",
      body: body,
    });
  }
}
